import hasPresentValue from './has-present-value'

const isMissingMinutesInCourses = (courses) => {
  return !courses.every((course) =>
    hasPresentValue(course.averageMinutesPerWeek)
  )
}
export default isMissingMinutesInCourses
